import { ColDef } from 'ag-grid-community';
import ItemTable from '../ItemTable';
import MobileItemTable from '../MobileItemTable/MobileItemTable';
import SingleItemCell from '../MenuItemTable/cells/SingleItemCell';
import PageNameCell from './cells/PageNameCell';
import { PageDefinitionInterface } from '../../constants/PagesConstants';

export interface PagesTableRow extends PageDefinitionInterface {
  isHidden: boolean;
  // Set when a backend-backed page's real visibility could not be loaded. We don't know the live
  // state, so the row must NOT be presented as a confident "Showing".
  statusUnknown?: boolean;
  unavailableNote?: string;
}

interface PagesTableProps {
  pages: PagesTableRow[];
  isDesktop?: boolean;
  onHideShow: Function;
  onDragEnd?: Function;
}

const PAGES_ROW_HEIGHT = 84;

const PagesTable = ({ pages, isDesktop, onHideShow, onDragEnd }: PagesTableProps) => {
  const COLUMNS: ColDef[] = [
    {
      headerName: 'PAGE',
      headerClass: 'name-header',
      valueGetter: (params) => ({
        id: params.data.id,
        label: params.data.label,
        route: params.data.route,
        isHidden: params.data.isHidden,
        statusUnknown: params.data.statusUnknown,
        unavailableNote: params.data.unavailableNote,
        alwaysVisible: params.data.alwaysVisible,
        draggable: !!isDesktop,
        onHideShow: () => onHideShow(params.data.id)
      }),
      cellRenderer: PageNameCell,
      minWidth: 280,
      sortable: false,
      suppressMovable: true,
      wrapText: true,
      autoHeight: true
    },
    {
      headerName: 'TITLE',
      headerClass: 'custom-header',
      valueGetter: (params) => ({ item: params.data.title, isHidden: params.data.isHidden }),
      cellRenderer: SingleItemCell,
      minWidth: 200,
      sortable: false,
      suppressMovable: true,
      wrapText: true,
      autoHeight: true
    }
  ];

  return isDesktop ? (
    <ItemTable
      className="pages-table"
      items={pages}
      columns={COLUMNS}
      draggable
      onDragEnd={onDragEnd}
      rowHeight={PAGES_ROW_HEIGHT}
    />
  ) : (
    <div className="pages-table-mobile-container">
      <MobileItemTable items={pages} columns={COLUMNS} draggable={false} rowHeight={PAGES_ROW_HEIGHT} />
    </div>
  );
};

export default PagesTable;
